import React, { useEffect, useState } from "react";
import { Display, Icon } from "../Main/styles";
import { CheckboxUnit, DBFilterCheckboxArea, DBFilterWrapper, DBTableExcelBtn, DateArea } from "../DB/styles";
import { ConfigProvider, Input, Table, DatePicker, Select, Checkbox, message } from "antd";
import { FaGear, FaPen } from "react-icons/fa6";
import { SearchArea } from "./styles";
import { FaSearch } from "react-icons/fa";
import { useBoardList } from "CRM/hooks/GetBoardList";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import { RangePickerProps } from "rc-picker/es/RangePicker.d";
import locale from "antd/lib/locale/ko_KR";
import WorkAdd from "CRM/components/Add/WorkAdd";
import BoardView from "CRM/components/BoardView";
import SetTemplate from "CRM/components/SetTemplate";
import { LEVEL, useMyInfo } from "../../hooks/GetMyInfo";
import API from "../../../utils/api";
import { useToken } from "../../../app/hooks";
import { useIsMobile } from "../../components/IsMobile";
import { ReactComponent as FilterArrowBottom } from "../../../assets/FilterArrowBottom.svg";
import styled from "styled-components";
import { useBoardComment } from "../../hooks/GetBoardComment";
import { useCategoryList } from "../../hooks/GetCategory";
import { useBranchList } from "../../hooks/GetBranchList";
const { RangePicker } = DatePicker;

export const Board = () => {
	const IsMobile = useIsMobile();
	const [scrollPosition, setScrollPosition] = useState(0);
	const { data: token } = useToken();
	const [createdAt, setCreatedAt] = useState<RangePickerProps<dayjs.Dayjs>["value"] | any>([null, null]);
	const [inputCreated, setInputCreated] = useState<RangePickerProps<dayjs.Dayjs>["value"] | any>([null, null]);
	const [search, setSearch] = useState("");
	const [inputSearch, setInputSearch] = useState("");
	const [status, setStatus] = useState("전체");
	const { categoryList } = useCategoryList();
	const [category, setCategory] = useState(0);
	const { branchList } = useBranchList();
	const [deptId, setDeptId] = useState(0);

	const { boardList, mutate } = useBoardList(
		deptId,
		category,
		status,
		search,
		createdAt?.[0] !== null ? `${dayjs(createdAt?.[0])?.format("YYYY-MM-DD")}~${dayjs(createdAt?.[1])?.format("YYYY-MM-DD")}` : ""
	);
	const [isRequest, setIsRequest] = useState(false);
	const [isSelect, setIsSelect] = useState(false);
	const [boardId, setBoardId] = useState<any>(null);
	const [selectedRows, setSelectedRows] = useState<number[]>([]);
	const [isAllChecked, setIsAllChecked] = useState(false);
	// const filterList = boardList?.filter(it => it.status == status)

	const { myInfo, level } = useMyInfo();

	const [isSetTemplate, setIsSetTemplate] = useState(false);

	const [isFilter, setIsFilter] = useState(false);

	useEffect(() => {
		if (level !== LEVEL.MASTER) {
			setDeptId(myInfo?.branchId);
		}
	}, [level, myInfo]);

	useEffect(() => {
		if (!isSelect && IsMobile) {
			window.scrollTo({ top: scrollPosition, behavior: "smooth" });
		} else if (isSelect && IsMobile) {
			window.scrollTo({ top: 0, behavior: "smooth" });
			setScrollPosition(window.scrollY);
		}
	}, [isSelect]);

	const clickSearch = () => {
		setCreatedAt(inputCreated);
		setSearch(inputSearch);
	};

	const handleSelectAllChange = (e) => {
		setIsAllChecked(e.target.checked);
		const ids = boardList.map((db) => db.id);
		setSelectedRows(e.target.checked ? ids : []);
	};

	const handleCheckboxChange = (e, id) => {
		if (e.target.checked) {
			setSelectedRows([...selectedRows, id]);
		} else {
			setSelectedRows(selectedRows?.filter((rowId) => rowId !== id));
		}
	};

	useEffect(() => {
		console.log("selectedRows", selectedRows);
	}, [selectedRows]);

	const clickDelete = () => {
		const shouldEdit = window.confirm(`선택한 내역을 삭제하시겠습니까?`);
		if (shouldEdit) {
			if (selectedRows?.length == 0) {
				message.error("선택한 내역이 없습니다.");
			} else {
				API.delete("/board/request", token + "", {
					ids: selectedRows,
				})
					.then((res: any) => {
						if (res.result.success) {
							message.success("삭제되었습니다.");
							mutate();
						}
					})
					.catch((err: any) => {});
			}
		}
	};

	const mobileColumns = [
		{
			dataIndex: "checkbox",
			title: <Checkbox checked={isAllChecked} onChange={handleSelectAllChange} />,
			render: (value, data) => {
				return (
					<div className="checkbox">
						<Checkbox
							style={{ justifyContent: "center", display: "flex" }}
							checked={selectedRows?.includes(data.id)}
							key={data?.id}
							onChange={(e) => handleCheckboxChange(e, data?.id)}
						/>
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "업무요청",
			render: (value, data) => {
				// console.log(data)
				return (
					<>
						<div
							className="tel"
							style={{
								minWidth: 200,
								textDecoration: "underline",
								cursor: "pointer",
								display: "flex",
								justifyContent: "flex-start",
							}}
							onClick={() => {
								setBoardId(data?.id);
								setIsSelect(true);
							}}
						>
							<p style={{ marginRight: 0, fontWeight: "bold" }}>요청시간: </p>
							{data?.createdAt}
						</div>
						<div className="path" style={{ display: "flex", justifyContent: "flex-start" }}>
							<p style={{ marginRight: 0, fontWeight: "bold" }}>지사명: </p> {data?.branchName}
						</div>
						<div
							className="request"
							style={{ display: "flex", justifyContent: "flex-start" }}
							onClick={() => {
								setBoardId(data?.id);
								setIsSelect(true);
							}}
						>
							<p style={{ marginRight: 0, fontWeight: "bold" }}>카테고리: </p>
							{data?.categoryName}
						</div>
						<div className="" style={{ display: "flex", justifyContent: "flex-start" }}>
							<p style={{ marginRight: 0, fontWeight: "bold" }}>플랫폼: </p> {data?.platformName}
						</div>
						<div className="date" style={{ display: "flex", justifyContent: "flex-start" }}>
							<p style={{ marginRight: 0, fontWeight: "bold", minWidth: 66 }}>고객이메일: </p>
							{data?.email}
						</div>
						<div className="date" style={{ minWidth: 200, display: "flex", justifyContent: "flex-start" }}>
							<p style={{ marginRight: 0, fontWeight: "bold" }}>완료시간: </p>
							{data?.completedAt}
						</div>
					</>
				);
			},
		},
	];

	const columns = [
		{
			dataIndex: "checkbox",
			title: <Checkbox checked={isAllChecked} onChange={handleSelectAllChange} />,
			render: (value, data) => {
				return (
					<div className="checkbox">
						<Checkbox
							style={{ justifyContent: "center", display: "flex" }}
							checked={selectedRows?.includes(data.id)}
							key={data?.id}
							onChange={(e) => handleCheckboxChange(e, data?.id)}
						/>
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "요청시간",
			render: (value, data) => {
				// console.log(data)
				return (
					<div
						className="tel"
						style={{ minWidth: 200, textDecoration: "underline", cursor: "pointer" }}
						onClick={() => {
							setBoardId(data?.id);
							setIsSelect(true);
						}}
					>
						{data?.createdAt}
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "지사명",
			render: (value, data) => {
				return <div className="path">{data?.branchName}</div>;
			},
		},
		{
			dataIndex: "",
			title: "카테고리",
			render: (value, data) => {
				return (
					<div
						className="request"
						onClick={() => {
							setBoardId(data?.id);
							setIsSelect(true);
						}}
					>
						{data?.categoryName}
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "플랫폼",
			render: (value, data) => {
				return <div className="">{data?.platformName}</div>;
			},
		},
		{
			dataIndex: "",
			title: "고객이메일",
			render: (value, data) => {
				return <div className="date">{data?.email}</div>;
			},
		},
		{
			dataIndex: "",
			title: "완료시간",
			render: (value, data) => {
				return (
					<div className="date" style={{ minWidth: 200 }}>
						{data?.completedAt}
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "댓글",
			render: (value, data) => {
				return (
					<div className="date" style={{ maxWidth: 50 }}>
						{data?.newComment === 0 ? "" : data?.commentCount}
					</div>
				);
			},
		},
	];

	return (
		<Display IsMobile={IsMobile}>
			{IsMobile && (
				<div
					style={{
						backgroundColor: "white",
						width: "100%",
						height: 40,
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						zIndex: 2,
						boxShadow: "2px 2px 8px 2px #74747476",
						cursor: "pointer",
					}}
					onClick={() => setIsFilter(!isFilter)}
				>
					<div style={{ marginLeft: 15 }}>필터</div>
					{isFilter ? <RotatedSvg style={{ width: 45, height: 25 }} /> : <FilterArrowBottom style={{ width: 45, height: 25 }} />}
				</div>
			)}

			<DBFilterWrapper>
				{IsMobile ? (
					<>
						{isFilter && (
							<DBFilterCheckboxArea IsMobile={IsMobile}>
								<div style={{ display: "flex", gap: 10 }}>
									<DBTableExcelBtn
										onClick={() => setIsRequest(true)}
										style={{ backgroundColor: "#437eff", color: "#fff" }}
									>
										<Icon>
											<FaPen />
										</Icon>
										업무 요청
									</DBTableExcelBtn>
									{myInfo?.master && (
										<DBTableExcelBtn
											onClick={() => setIsSetTemplate(true)}
											style={{ backgroundColor: "#FF9F01", color: "#fff" }}
										>
											<Icon>
												<FaGear />
											</Icon>
											템플릿 관리
										</DBTableExcelBtn>
									)}
								</div>

								<Select
									value={category}
									onChange={(e) => setCategory(e)}
									placeholder="카테고리 선택"
									style={{ fontFamily: "Pretendard" }}
								>
									<option value={0}>전체</option>
									{categoryList?.map((it) => (
										<option value={it.id} style={{ fontFamily: "Pretendard" }}>
											{it.name}
										</option>
									))}
								</Select>

								<DateArea>
									<label htmlFor="createdAt">지사</label>
									<Select
										value={deptId}
										onChange={(e) => setDeptId(e)}
										placeholder="지사 선택"
										style={{ fontFamily: "Pretendard", width: 100 }}
									>
										<option value={0}>전체</option>
										{process.env.REACT_APP_API_URL?.includes("ccl") && (
											<option value={1}>본사</option>
										)}
										{branchList?.map((it) => (
											<option value={it.id} style={{ fontFamily: "Pretendard" }}>
												{it.name}
											</option>
										))}
									</Select>
								</DateArea>

								<DateArea>
									<label htmlFor="createdAt">등록일</label>
									<ConfigProvider locale={locale}>
										<RangePicker
											id="createdAt"
											value={inputCreated}
											onChange={(values) => setInputCreated(values)}
										/>
									</ConfigProvider>
								</DateArea>
								<DateArea>
									<label htmlFor="createdAt">상태</label>
									<Select
										value={status}
										onChange={(e) => setStatus(e)}
										style={{ fontFamily: "Pretendard" }}
									>
										<option value={"전체"} style={{ fontFamily: "Pretendard" }}>
											전체
										</option>
										<option value={0} style={{ fontFamily: "Pretendard" }}>
											처리중
										</option>
										<option value={1} style={{ fontFamily: "Pretendard" }}>
											보류
										</option>
										<option value={2} style={{ fontFamily: "Pretendard" }}>
											완료
										</option>
									</Select>
								</DateArea>
								<DateArea>
									<label htmlFor="search">검색어</label>
									<Input
										type="text"
										id="search"
										value={inputSearch}
										onChange={(e) => setInputSearch(e.target.value)}
										placeholder=""
									/>
								</DateArea>

								<div style={{ display: "flex", gap: 10 }}>
									<DBTableExcelBtn
										onClick={clickSearch}
										style={{ backgroundColor: "#437eff", color: "#fff" }}
									>
										<Icon>
											<FaSearch />
										</Icon>
										검색
									</DBTableExcelBtn>

									{myInfo?.master && (
										<DBTableExcelBtn
											onClick={clickDelete}
											style={{ backgroundColor: "#f93e3e", color: "#fff" }}
										>
											선택 삭제
										</DBTableExcelBtn>
									)}
								</div>
							</DBFilterCheckboxArea>
						)}
					</>
				) : (
					<DBFilterCheckboxArea IsMobile={IsMobile}>
						<div style={{ display: "flex", gap: 10 }}>
							<DBTableExcelBtn
								onClick={() => setIsRequest(true)}
								style={{ backgroundColor: "#437eff", color: "#fff" }}
							>
								<Icon>
									<FaPen />
								</Icon>
								업무 요청
							</DBTableExcelBtn>
							{myInfo?.master && (
								<DBTableExcelBtn
									onClick={() => setIsSetTemplate(true)}
									style={{ backgroundColor: "#FF9F01", color: "#fff" }}
								>
									<Icon>
										<FaGear />
									</Icon>
									템플릿 관리
								</DBTableExcelBtn>
							)}
						</div>

						{level == LEVEL.MASTER && (
							<DateArea>
								<label htmlFor="createdAt">카테고리</label>
								<Select
									value={category}
									onChange={(e) => setCategory(e)}
									placeholder="카테고리 선택"
									style={{ fontFamily: "Pretendard", width: 150 }}
								>
									<option value={0}>전체</option>
									{categoryList?.map((it) => (
										<option value={it.id} style={{ fontFamily: "Pretendard" }}>
											{it.name}
										</option>
									))}
								</Select>
							</DateArea>
						)}

						{level == LEVEL.MASTER && (
							<DateArea>
								<label htmlFor="createdAt">지사</label>
								<Select
									value={deptId}
									onChange={(e) => setDeptId(e)}
									placeholder="지사 선택"
									style={{ fontFamily: "Pretendard", width: 100 }}
								>
									<option value={0}>전체</option>
									{process.env.REACT_APP_API_URL?.includes("ccl") && <option value={1}>본사</option>}
									{branchList?.map((it) => (
										<option value={it.id} style={{ fontFamily: "Pretendard" }}>
											{it.name}
										</option>
									))}
								</Select>
							</DateArea>
						)}

						<DateArea>
							<label htmlFor="createdAt">등록일</label>
							<ConfigProvider locale={locale}>
								<RangePicker
									id="createdAt"
									value={inputCreated}
									onChange={(values) => setInputCreated(values)}
								/>
							</ConfigProvider>
						</DateArea>
						<DateArea>
							<label htmlFor="createdAt">상태</label>
							<Select value={status} onChange={(e) => setStatus(e)} style={{ fontFamily: "Pretendard" }}>
								<option value={"전체"} style={{ fontFamily: "Pretendard" }}>
									전체
								</option>
								<option value={0} style={{ fontFamily: "Pretendard" }}>
									처리중
								</option>
								<option value={1} style={{ fontFamily: "Pretendard" }}>
									보류
								</option>
								<option value={2} style={{ fontFamily: "Pretendard" }}>
									완료
								</option>
							</Select>
						</DateArea>
						<DateArea>
							<label htmlFor="search">검색어</label>
							<Input
								type="text"
								id="search"
								value={inputSearch}
								onChange={(e) => setInputSearch(e.target.value)}
								placeholder=""
							/>
						</DateArea>

						<div style={{ display: "flex", gap: 10 }}>
							<DBTableExcelBtn onClick={clickSearch} style={{ backgroundColor: "#437eff", color: "#fff" }}>
								<Icon>
									<FaSearch />
								</Icon>
								검색
							</DBTableExcelBtn>

							{myInfo?.master && (
								<DBTableExcelBtn onClick={clickDelete} style={{ backgroundColor: "#f93e3e", color: "#fff" }}>
									선택 삭제
								</DBTableExcelBtn>
							)}
						</div>
					</DBFilterCheckboxArea>
				)}

				<Table
					className="BoardTable"
					rowClassName={(record) => {
						const answered = record?.status == 2;
						const hold = record?.status == 1;
						return answered ? "answered" : hold ? "hold" : "";
					}}
					dataSource={boardList}
					columns={IsMobile ? mobileColumns : columns}
					bordered={true}
				/>
			</DBFilterWrapper>
			{isRequest && <WorkAdd setIsRequest={setIsRequest} mutate={mutate} />}
			{isSelect && <BoardView setIsSelect={setIsSelect} boardId={boardId} getBoadListMutate={mutate} />}
			{isSetTemplate && <SetTemplate setIsSetTemplate={setIsSetTemplate} />}
		</Display>
	);
};

export default React.memo(Board);

const RotatedSvg = styled(FilterArrowBottom)`
	transform: rotate(180deg);
	width: 45px;
	height: 25px;
`;
